import client from '../../client'
import {
  FacilityId,
  FavoriteTimetablesResponse,
  FavoriteFacilitesResponse,
  ListFavoritesSearchAttributesResponse,
  ListFavoriteTimetableParams,
  ListFavoriteFacilitiesParams,
} from './types'
import { ApiResponse } from '../../types'

export * from './types'

export const listTimetables = async (params?: ListFavoriteTimetableParams) => {
  const { data }: ApiResponse<FavoriteTimetablesResponse> = await client.get(
    '/user/favorites/timetables',
    { params }
  )
  return data
}

export const listFacilities = async (params?: ListFavoriteFacilitiesParams) => {
  const { data }: ApiResponse<FavoriteFacilitesResponse> = await client.get(
    '/user/favorites/facilities',
    { params }
  )
  return data
}

export const listSearchAttributes = async () => {
  const { data }: ApiResponse<ListFavoritesSearchAttributesResponse> =
    await client.get('/user/favorites/attributes')
  return data
}

export const addFacility = async (facilityId: FacilityId) =>
  await client.post('/user/favorites/facilities', { facility_id: facilityId })

export const removeFacility = async (facilityId: FacilityId) =>
  await client.delete(`/user/favorites/facilities/${facilityId}`)
